import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadLocations = async () => {
  try {
    const response = await Axios.get('locations');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneLocation = async (name) => {
  try {
    const respnse = await Axios.get('locations/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadMovesHistory = async (location) => {
  try {
    const filter = encodeURI(JSON.stringify({status: 'done', location: location}))
    const respnse = await Axios.get('locations/products/moves/history/'+filter);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadLocation = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/locations');
        const responseData = await response.data;
        return {...responseData, location: {}};
        
      default:
        const data = await loadOneLocation(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

export const loadLocationCurrentStock = async (seo) => {
  try {
    const respnse = await Axios.get(`locations/${seo}/stock`);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}


const useLocationAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('locations', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('location_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (name, data, success) => {
    try {
      const respnse = await Axios.put('locations/'+name, data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useLocationAPI;


